var _circle, _circle2, _g, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutYou({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "#EEF6FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 129
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "#EEF6FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.3458,
    cy: 47.0104,
    r: 22.0104,
    fill: "#007580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8538 138.936C74.8538 143.39 71.2437 147 66.7904 147H53.2375C33.7764 147 18 131.223 18 111.762V104.951C18 89.2518 30.7272 76.5246 46.4269 76.5246V76.5246C62.1266 76.5246 74.8538 89.2518 74.8538 104.951V138.936Z",
    fill: "#007580"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 57C76.3431 57 75 55.6569 75 54L75 33.5C75 20.5213 85.5213 10 98.5 10L101.057 10C112.623 10 122 19.3767 122 30.9434V30.9434C122 45.334 110.334 57 95.9434 57L78 57Z",
    fill: "#284993"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 24,
    width: 37,
    height: 2,
    rx: 0.940133,
    fill: "#E9EDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 42,
    width: 21,
    height: 2,
    rx: 0.940133,
    fill: "#E9EDF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 30,
    width: 37,
    height: 2,
    rx: 0.940133,
    fill: "#E9EDF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 36,
    width: 37,
    height: 2,
    rx: 0.940133,
    fill: "#E9EDF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutYou);
export default __webpack_public_path__ + "static/media/about-you.16b838071e2a5e0e8f58854ac66e3972.svg";
export { ForwardRef as ReactComponent };